import { API_URL } from './base';
import api from './api';

export const fetchUserList = () => {
    return api.get(`${API_URL}/admin/admin-users-list/`).then(resp => {
        return resp.data;
    });
};
